"use client";
import { motion } from "framer-motion";
import type { ReactNode } from "react";

type ScrollRevealProps = {
  children: ReactNode;
  className?: string;
  delay?: number;
  /** Pixels to translate up from on entry. */
  distance?: number;
};

/**
 * Fade-in + slide-up on scroll into view. Shared building block for the
 * "Scroll Reveal" animation called out across the homepage spec.
 */
export default function ScrollReveal({
  children,
  className = "",
  delay = 0,
  distance = 24,
}: ScrollRevealProps) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: distance }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10% 0px" }}
      transition={{ duration: 0.5, delay, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
}
